export const LIKERT_DELIMITER = '~'
